export default __webpack_public_path__ + "static/media/upload-ecommerce-1.d1754903.webp";